// todo question拦截器添加header数据参数
export default [
  config => {
    config.headers.Brand = 'zsk_web'
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  },
]
